// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-page {
    width: min(960px, calc(100% - 64px));
    min-height: calc(100dvh - 72px);
    margin: 0 auto;
    padding: clamp(44px, 5vw, 72px) 0 112px;
    background: var(--tp-bg);
    color: var(--tp-text);
}

.create-intro {
    max-width: 780px;
    margin-bottom: clamp(40px, 5vw, 60px);
}

.create-label {
    margin: 0 0 16px;
    color: var(--tp-signal);
    font-size: 11px;
    font-weight: 850;
    letter-spacing: .14em;
}

.create-title {
    max-width: 17ch;
    margin: 0 0 22px;
    font-size: var(--tp-title-page);
    font-weight: 850;
    line-height: 1.1;
    letter-spacing: -.045em;
    word-break: keep-all;
}

.create-intro > p:last-child {
    max-width: 58ch;
    margin: 0;
    color: var(--tp-muted);
    font-size: 15px;
    line-height: 1.7;
}

.create-card {
    display: block;
    padding: 0;
    border-top: 3px solid var(--tp-ink);
    background: transparent;
}

.create-page .category-section {
    min-height: 110px;
    padding: 24px 0;
    display: grid;
    grid-template-columns: minmax(0, 1fr) 260px;
    gap: 32px;
    align-items: center;
    border-bottom: 1px solid var(--tp-rule);
}

.create-page .category-label,
.field-label {
    margin: 0;
    color: var(--tp-ink);
    font-size: 14px;
    font-weight: 850;
}

.create-page .category-description,
.field-help {
    margin: 6px 0 0;
    color: var(--tp-muted);
    font-size: 12px;
    line-height: 1.55;
}

.create-page .category-select-wrap { position: relative; }

.create-page .category-select {
    width: 100%;
    min-height: 50px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid var(--tp-rule);
    border-radius: var(--tp-radius-control);
    background: var(--tp-sheet);
    color: var(--tp-ink);
    font-size: 13px;
    font-weight: 750;
    cursor: pointer;
}

.create-page .category-arrow {
    transition: transform 160ms ease;
}

.create-page .category-arrow.open { transform: rotate(180deg); }

.create-page .category-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    left: 0;
    z-index: 30;
    max-height: 280px;
    overflow-y: auto;
    padding: 8px;
    border: 1px solid var(--tp-rule);
    border-radius: var(--tp-radius-control);
    background: var(--tp-sheet);
    box-shadow: var(--tp-shadow-overlay);
}

.create-page .category-option {
    width: 100%;
    min-height: 44px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 0;
    border-radius: 7px;
    background: transparent;
    color: var(--tp-ink);
    font-size: 13px;
    text-align: left;
    cursor: pointer;
}

.create-page .category-option:hover,
.create-page .category-option.selected { background: var(--tp-bg); }
.create-page .category-check { color: var(--tp-signal); font-weight: 900; }

.create-field { padding-top: 30px; }

.create-field-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
}

.create-field-heading > span {
    color: var(--tp-muted);
    font-size: 11px;
    font-weight: 750;
}

.create-textarea {
    width: 100%;
    min-height: 280px;
    margin-top: 18px;
    padding: 22px 0;
    border: 0;
    border-block: 1px solid var(--tp-rule);
    border-radius: 0;
    outline: 0;
    resize: vertical;
    background: transparent;
    color: var(--tp-ink);
    font-size: clamp(24px, 3.6vw, 38px);
    font-weight: 680;
    line-height: 1.45;
    letter-spacing: -.035em;
}

.create-textarea::placeholder { color: var(--tp-muted); opacity: .72; }
.create-textarea:focus { border-block-color: var(--tp-ink); }

.create-error {
    margin: 18px 0 0;
    padding: 13px 15px;
    border-left: 3px solid var(--tp-error);
    background: color-mix(in srgb, var(--tp-error) 8%, var(--tp-surface));
    color: var(--tp-error);
    font-size: 13px;
    font-weight: 700;
}

.create-actions {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.create-button,
.create-secondary-button {
    min-height: 50px;
    padding: 0 22px;
    border: 1px solid var(--tp-ink);
    border-radius: var(--tp-radius-control);
    font-size: 14px;
    font-weight: 800;
    cursor: pointer;
}

.create-button {
    background: var(--tp-ink);
    color: var(--tp-sheet);
}

.create-secondary-button {
    background: transparent;
    color: var(--tp-ink);
}

.create-button:disabled { opacity: .55; cursor: wait; }

.photo-create-page .create-card { padding-top: 28px; }

.photo-upload-section {
    width: 100%;
    min-height: 360px;
    margin-top: 18px;
    padding: 0;
    display: grid;
    place-items: center;
    overflow: hidden;
    border: 1px dashed var(--tp-ink);
    border-radius: var(--tp-radius-surface);
    background: var(--tp-bg);
    color: var(--tp-ink);
    cursor: pointer;
}

.photo-upload-section.has-preview { border-style: solid; background: var(--tp-sheet); }

.photo-upload-empty { display: grid; gap: 8px; text-align: center; }
.photo-upload-empty strong { font-size: 18px; }
.photo-upload-empty span { color: var(--tp-muted); font-size: 13px; }

.photo-preview {
    width: 100%;
    max-height: 620px;
    display: block;
    object-fit: contain;
}

.photo-upload-input {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
    clip-path: inset(50%);
}

.create-editorial { margin-top:36px; padding-top:22px; border-top:1px solid var(--tp-rule); }
.create-editorial h2 { margin:0 0 15px; font-size:15px; letter-spacing:-.03em; }
.create-editorial ol { margin:0; padding-left:18px; color:var(--tp-muted); font-size:12px; line-height:1.8; }
.create-editorial ol li+li { margin-top:5px; }
.create-recent ul { margin:0; padding:0; list-style:none; }
.create-recent li { padding:10px 0; border-top:1px solid var(--tp-rule); }
.create-recent li a { display:block; color:var(--tp-text); font-size:12px; line-height:1.5; text-decoration:none; }
.create-recent li a:hover { text-decoration:underline; }
.create-recent li span { display:block; margin-bottom:3px; color:var(--tp-signal-deep); font-size:10px; font-weight:850; }
.create-more-link { display:inline-block; margin-top:12px; color:var(--tp-signal-deep); font-size:11px; font-weight:850; text-decoration:none; }
.create-photo-samples { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:7px; }
.create-photo-samples a { min-width:0; color:var(--tp-text); text-decoration:none; }
.create-photo-samples img { width:100%; aspect-ratio:1; display:block; object-fit:cover; border-radius:5px; }
.create-photo-samples span { display:block; margin-top:5px; overflow:hidden; white-space:nowrap; text-overflow:ellipsis; font-size:10px; }
.photo-caption-field { display:grid; gap:10px; }
.photo-caption-input,.photo-caption-textarea { width:100%; padding:14px 16px; border:1px solid var(--tp-rule-strong); border-radius:7px; background:var(--tp-surface-strong); color:var(--tp-text); font:inherit; font-size:14px; }
.photo-caption-textarea { min-height:130px; resize:vertical; line-height:1.65; }
.photo-caption-input:focus,.photo-caption-textarea:focus { outline:2px solid var(--tp-signal); outline-offset:1px; }

@media (max-width: 767px) {
    .create-page {
        width: calc(100% - 36px);
        min-height: calc(100dvh - 64px);
        padding: 34px 0 116px;
    }

    .create-intro { margin-bottom: 40px; }
    .create-title { font-size: var(--tp-title-page-mobile); }

    .create-page .category-section {
        padding: 22px 0;
        display: block;
    }

    .create-page .category-select-wrap { margin-top: 16px; }
    .create-textarea { min-height: 220px; font-size: 24px; }
    .create-actions { display: grid; grid-template-columns: 1fr 1fr; }
    .photo-upload-section { min-height: 280px; }
}
.create-video-reference a,.create-video-reference button{display:inline-flex;align-items:center;min-height:38px;margin:7px 8px 0 0;padding:0 12px;border:1px solid currentColor;border-radius:8px;background:transparent;color:inherit;font-size:12px;font-weight:800;text-decoration:none;cursor:pointer}
`, "",{"version":3,"sources":["webpack://./src/pages/CreatePostPage.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,+BAA+B;IAC/B,cAAc;IACd,uCAAuC;IACvC,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,mCAAmC;IACnC,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,2CAA2C;IAC3C,SAAS;IACT,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;;IAEI,SAAS;IACT,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,iBAAiB;AACrB;;AAEA,qCAAqC,kBAAkB,EAAE;;AAEzD;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gCAAgC;IAChC,uCAAuC;IACvC,2BAA2B;IAC3B,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA,oCAAoC,yBAAyB,EAAE;;AAE/D;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,uCAAuC;IACvC,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;yCACyC,wBAAwB,EAAE;AACnE,+BAA+B,uBAAuB,EAAE,gBAAgB,EAAE;;AAE1E,gBAAgB,iBAAiB,EAAE;;AAEnC;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,sCAAsC;IACtC,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,mCAAmC;IACnC,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA,gCAAgC,sBAAsB,EAAE,YAAY,EAAE;AACtE,yBAAyB,iCAAiC,EAAE;;AAE5D;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,qEAAqE;IACrE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA,0BAA0B,YAAY,EAAE,YAAY,EAAE;;AAEtD,kCAAkC,iBAAiB,EAAE;;AAErD;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;IAChC,uCAAuC;IACvC,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;AACnB;;AAEA,oCAAoC,mBAAmB,EAAE,2BAA2B,EAAE;;AAEtF,sBAAsB,aAAa,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AACnE,6BAA6B,eAAe,EAAE;AAC9C,2BAA2B,sBAAsB,EAAE,eAAe,EAAE;;AAEpE;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,mCAAmC,EAAE;AAC5F,uBAAuB,eAAe,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAC/E,uBAAuB,QAAQ,EAAE,iBAAiB,EAAE,qBAAqB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC5G,6BAA6B,cAAc,EAAE;AAC7C,oBAAoB,QAAQ,EAAE,SAAS,EAAE,eAAe,EAAE;AAC1D,oBAAoB,cAAc,EAAE,mCAAmC,EAAE;AACzE,sBAAsB,aAAa,EAAE,oBAAoB,EAAE,cAAc,EAAE,eAAe,EAAE,oBAAoB,EAAE;AAClH,4BAA4B,yBAAyB,EAAE;AACvD,yBAAyB,aAAa,EAAE,iBAAiB,EAAE,2BAA2B,EAAE,cAAc,EAAE,eAAe,EAAE;AACzH,oBAAoB,oBAAoB,EAAE,eAAe,EAAE,2BAA2B,EAAE,cAAc,EAAE,eAAe,EAAE,oBAAoB,EAAE;AAC/I,wBAAwB,YAAY,EAAE,6CAA6C,EAAE,OAAO,EAAE;AAC9F,0BAA0B,WAAW,EAAE,oBAAoB,EAAE,oBAAoB,EAAE;AACnF,4BAA4B,UAAU,EAAE,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC5G,6BAA6B,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,cAAc,EAAE;AACzI,uBAAuB,YAAY,EAAE,QAAQ,EAAE;AAC/C,+CAA+C,UAAU,EAAE,iBAAiB,EAAE,sCAAsC,EAAE,iBAAiB,EAAE,mCAAmC,EAAE,oBAAoB,EAAE,YAAY,EAAE,cAAc,EAAE;AAClO,0BAA0B,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC/E,2DAA2D,kCAAkC,EAAE,kBAAkB,EAAE;;AAEnH;IACI;QACI,wBAAwB;QACxB,+BAA+B;QAC/B,qBAAqB;IACzB;;IAEA,gBAAgB,mBAAmB,EAAE;IACrC,gBAAgB,sCAAsC,EAAE;;IAExD;QACI,eAAe;QACf,cAAc;IAClB;;IAEA,qCAAqC,gBAAgB,EAAE;IACvD,mBAAmB,iBAAiB,EAAE,eAAe,EAAE;IACvD,kBAAkB,aAAa,EAAE,8BAA8B,EAAE;IACjE,wBAAwB,iBAAiB,EAAE;AAC/C;AACA,yDAAyD,mBAAmB,CAAC,kBAAkB,CAAC,eAAe,CAAC,kBAAkB,CAAC,cAAc,CAAC,6BAA6B,CAAC,iBAAiB,CAAC,sBAAsB,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,oBAAoB,CAAC,cAAc","sourcesContent":[".create-page {\n    width: min(960px, calc(100% - 64px));\n    min-height: calc(100dvh - 72px);\n    margin: 0 auto;\n    padding: clamp(44px, 5vw, 72px) 0 112px;\n    background: var(--tp-bg);\n    color: var(--tp-text);\n}\n\n.create-intro {\n    max-width: 780px;\n    margin-bottom: clamp(40px, 5vw, 60px);\n}\n\n.create-label {\n    margin: 0 0 16px;\n    color: var(--tp-signal);\n    font-size: 11px;\n    font-weight: 850;\n    letter-spacing: .14em;\n}\n\n.create-title {\n    max-width: 17ch;\n    margin: 0 0 22px;\n    font-size: var(--tp-title-page);\n    font-weight: 850;\n    line-height: 1.1;\n    letter-spacing: -.045em;\n    word-break: keep-all;\n}\n\n.create-intro > p:last-child {\n    max-width: 58ch;\n    margin: 0;\n    color: var(--tp-muted);\n    font-size: 15px;\n    line-height: 1.7;\n}\n\n.create-card {\n    display: block;\n    padding: 0;\n    border-top: 3px solid var(--tp-ink);\n    background: transparent;\n}\n\n.create-page .category-section {\n    min-height: 110px;\n    padding: 24px 0;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 260px;\n    gap: 32px;\n    align-items: center;\n    border-bottom: 1px solid var(--tp-rule);\n}\n\n.create-page .category-label,\n.field-label {\n    margin: 0;\n    color: var(--tp-ink);\n    font-size: 14px;\n    font-weight: 850;\n}\n\n.create-page .category-description,\n.field-help {\n    margin: 6px 0 0;\n    color: var(--tp-muted);\n    font-size: 12px;\n    line-height: 1.55;\n}\n\n.create-page .category-select-wrap { position: relative; }\n\n.create-page .category-select {\n    width: 100%;\n    min-height: 50px;\n    padding: 0 15px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid var(--tp-rule);\n    border-radius: var(--tp-radius-control);\n    background: var(--tp-sheet);\n    color: var(--tp-ink);\n    font-size: 13px;\n    font-weight: 750;\n    cursor: pointer;\n}\n\n.create-page .category-arrow {\n    transition: transform 160ms ease;\n}\n\n.create-page .category-arrow.open { transform: rotate(180deg); }\n\n.create-page .category-dropdown {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    left: 0;\n    z-index: 30;\n    max-height: 280px;\n    overflow-y: auto;\n    padding: 8px;\n    border: 1px solid var(--tp-rule);\n    border-radius: var(--tp-radius-control);\n    background: var(--tp-sheet);\n    box-shadow: var(--tp-shadow-overlay);\n}\n\n.create-page .category-option {\n    width: 100%;\n    min-height: 44px;\n    padding: 0 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 0;\n    border-radius: 7px;\n    background: transparent;\n    color: var(--tp-ink);\n    font-size: 13px;\n    text-align: left;\n    cursor: pointer;\n}\n\n.create-page .category-option:hover,\n.create-page .category-option.selected { background: var(--tp-bg); }\n.create-page .category-check { color: var(--tp-signal); font-weight: 900; }\n\n.create-field { padding-top: 30px; }\n\n.create-field-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n}\n\n.create-field-heading > span {\n    color: var(--tp-muted);\n    font-size: 11px;\n    font-weight: 750;\n}\n\n.create-textarea {\n    width: 100%;\n    min-height: 280px;\n    margin-top: 18px;\n    padding: 22px 0;\n    border: 0;\n    border-block: 1px solid var(--tp-rule);\n    border-radius: 0;\n    outline: 0;\n    resize: vertical;\n    background: transparent;\n    color: var(--tp-ink);\n    font-size: clamp(24px, 3.6vw, 38px);\n    font-weight: 680;\n    line-height: 1.45;\n    letter-spacing: -.035em;\n}\n\n.create-textarea::placeholder { color: var(--tp-muted); opacity: .72; }\n.create-textarea:focus { border-block-color: var(--tp-ink); }\n\n.create-error {\n    margin: 18px 0 0;\n    padding: 13px 15px;\n    border-left: 3px solid var(--tp-error);\n    background: color-mix(in srgb, var(--tp-error) 8%, var(--tp-surface));\n    color: var(--tp-error);\n    font-size: 13px;\n    font-weight: 700;\n}\n\n.create-actions {\n    margin-top: 30px;\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n}\n\n.create-button,\n.create-secondary-button {\n    min-height: 50px;\n    padding: 0 22px;\n    border: 1px solid var(--tp-ink);\n    border-radius: var(--tp-radius-control);\n    font-size: 14px;\n    font-weight: 800;\n    cursor: pointer;\n}\n\n.create-button {\n    background: var(--tp-ink);\n    color: var(--tp-sheet);\n}\n\n.create-secondary-button {\n    background: transparent;\n    color: var(--tp-ink);\n}\n\n.create-button:disabled { opacity: .55; cursor: wait; }\n\n.photo-create-page .create-card { padding-top: 28px; }\n\n.photo-upload-section {\n    width: 100%;\n    min-height: 360px;\n    margin-top: 18px;\n    padding: 0;\n    display: grid;\n    place-items: center;\n    overflow: hidden;\n    border: 1px dashed var(--tp-ink);\n    border-radius: var(--tp-radius-surface);\n    background: var(--tp-bg);\n    color: var(--tp-ink);\n    cursor: pointer;\n}\n\n.photo-upload-section.has-preview { border-style: solid; background: var(--tp-sheet); }\n\n.photo-upload-empty { display: grid; gap: 8px; text-align: center; }\n.photo-upload-empty strong { font-size: 18px; }\n.photo-upload-empty span { color: var(--tp-muted); font-size: 13px; }\n\n.photo-preview {\n    width: 100%;\n    max-height: 620px;\n    display: block;\n    object-fit: contain;\n}\n\n.photo-upload-input {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n    white-space: nowrap;\n    clip-path: inset(50%);\n}\n\n.create-editorial { margin-top:36px; padding-top:22px; border-top:1px solid var(--tp-rule); }\n.create-editorial h2 { margin:0 0 15px; font-size:15px; letter-spacing:-.03em; }\n.create-editorial ol { margin:0; padding-left:18px; color:var(--tp-muted); font-size:12px; line-height:1.8; }\n.create-editorial ol li+li { margin-top:5px; }\n.create-recent ul { margin:0; padding:0; list-style:none; }\n.create-recent li { padding:10px 0; border-top:1px solid var(--tp-rule); }\n.create-recent li a { display:block; color:var(--tp-text); font-size:12px; line-height:1.5; text-decoration:none; }\n.create-recent li a:hover { text-decoration:underline; }\n.create-recent li span { display:block; margin-bottom:3px; color:var(--tp-signal-deep); font-size:10px; font-weight:850; }\n.create-more-link { display:inline-block; margin-top:12px; color:var(--tp-signal-deep); font-size:11px; font-weight:850; text-decoration:none; }\n.create-photo-samples { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:7px; }\n.create-photo-samples a { min-width:0; color:var(--tp-text); text-decoration:none; }\n.create-photo-samples img { width:100%; aspect-ratio:1; display:block; object-fit:cover; border-radius:5px; }\n.create-photo-samples span { display:block; margin-top:5px; overflow:hidden; white-space:nowrap; text-overflow:ellipsis; font-size:10px; }\n.photo-caption-field { display:grid; gap:10px; }\n.photo-caption-input,.photo-caption-textarea { width:100%; padding:14px 16px; border:1px solid var(--tp-rule-strong); border-radius:7px; background:var(--tp-surface-strong); color:var(--tp-text); font:inherit; font-size:14px; }\n.photo-caption-textarea { min-height:130px; resize:vertical; line-height:1.65; }\n.photo-caption-input:focus,.photo-caption-textarea:focus { outline:2px solid var(--tp-signal); outline-offset:1px; }\n\n@media (max-width: 767px) {\n    .create-page {\n        width: calc(100% - 36px);\n        min-height: calc(100dvh - 64px);\n        padding: 34px 0 116px;\n    }\n\n    .create-intro { margin-bottom: 40px; }\n    .create-title { font-size: var(--tp-title-page-mobile); }\n\n    .create-page .category-section {\n        padding: 22px 0;\n        display: block;\n    }\n\n    .create-page .category-select-wrap { margin-top: 16px; }\n    .create-textarea { min-height: 220px; font-size: 24px; }\n    .create-actions { display: grid; grid-template-columns: 1fr 1fr; }\n    .photo-upload-section { min-height: 280px; }\n}\n.create-video-reference a,.create-video-reference button{display:inline-flex;align-items:center;min-height:38px;margin:7px 8px 0 0;padding:0 12px;border:1px solid currentColor;border-radius:8px;background:transparent;color:inherit;font-size:12px;font-weight:800;text-decoration:none;cursor:pointer}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
